import { styled } from '@mui/material/styles';
import { Paper, Button } from '@mui/material';
import { isDark } from '../../styles';

export const Container = styled('div')(({ theme }) => ({
  margin: theme.spacing(4),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',

  '& .MuiTypography-root': {
    color: isDark(theme) ? theme.palette.common.white : theme.palette.primary.main,
  },

  // Apply iconLarge size styling to large icons inside this container
  '& .MuiSvgIcon-fontSizeLarge': {
    fontSize: '6rem',
    color: isDark(theme) ? theme.palette.common.white : theme.palette.primary.light,
  },
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%',
  maxWidth: '512px',
  textAlign: 'center',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
  backgroundColor: theme.palette.primary.dark,
}));
